import React from 'react';
import t from 'prop-types';

import Footer from '../Footer/Footer';

import Logo from '../../../assets/logo-long.png';
import confettiImage from '../../../assets/confetti.svg';

import styles from './ProfileLayout.scss';

const ProfileLayout = ({ children, withConfetti = false }) => (
  <div className={styles.container}>
    {withConfetti && (
      <div className={styles.confettiWrapper}>
        <img src={confettiImage} alt="" className={styles.confetti} width="1210" height="110" />
      </div>
    )}

    <main className={styles.wrapper}>
      <header className={styles.header}>
        <a href="https://clearvpn.com/" className={styles.logo}>
          <img src={Logo} width="119" height="32" alt="" />
        </a>

        {children}
      </header>
    </main>

    <Footer />
  </div>
);

ProfileLayout.propTypes = {
  children: t.element,
  withConfetti: t.bool,
};

export default ProfileLayout;
